/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Speaker On',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <g clip-path="url(#clip0_59_39)">
            {' '}
            <path
              d="M14.1244 2.26826C13.7889 2.08151 13.4091 1.98908 13.0254 2.00103C12.6416 2.01287 12.2682 2.12859 11.945 2.33581L4.76679 6.36506H2.45447C1.80378 6.36582 1.1799 6.62463 0.719738 7.0848C0.259574 7.54496 0.000775789 8.16884 0 8.81953V14.8198C0.000662912 15.4707 0.259477 16.0945 0.719641 16.5548C1.17978 17.0149 1.80368 17.2738 2.45447 17.2746H4.76669L11.9444 21.3038C12.2676 21.5111 12.641 21.6268 13.0248 21.6386C13.4085 21.6506 13.7882 21.5581 14.1237 21.3714C14.4735 21.1782 14.7649 20.8945 14.9672 20.5499C15.1695 20.2052 15.2752 19.8125 15.2734 19.4129V4.22682C15.2754 3.82728 15.1697 3.43454 14.9676 3.08992C14.7653 2.7453 14.4741 2.46146 14.1244 2.26826ZM1.0911 14.8198V8.81956C1.09157 8.45809 1.23533 8.11158 1.49102 7.85598C1.74662 7.60029 2.09313 7.45652 2.4546 7.45606H4.36396V16.1837H2.4546C2.09313 16.1832 1.74652 16.0394 1.49092 15.7837C1.23523 15.528 1.09146 15.1814 1.0911 14.8198ZM14.1825 19.4134C14.1859 19.6174 14.1335 19.8185 14.031 19.9949C13.9285 20.1712 13.7797 20.3162 13.6007 20.4142C13.4345 20.5085 13.2454 20.5548 13.0545 20.548C12.8636 20.5413 12.6782 20.4818 12.519 20.3762C12.51 20.3704 12.501 20.3651 12.4919 20.3599L5.45481 16.4097V7.22989L12.4912 3.27967C12.5002 3.27446 12.5092 3.26916 12.5183 3.26338C12.6775 3.15779 12.8628 3.09822 13.0537 3.0915C13.2447 3.08478 13.4338 3.13108 13.6 3.22531C13.779 3.32333 13.9277 3.4683 14.0302 3.64465C14.1328 3.82108 14.1852 4.02212 14.1818 4.2261L14.1825 19.4134Z"
              fill="currentColor"
            />{' '}
            <path
              d="M21.8483 4.96172C21.7368 4.80187 21.5485 4.71361 21.3543 4.73027C21.1601 4.74694 20.9896 4.86598 20.9069 5.04241C20.8242 5.21893 20.8419 5.42613 20.9535 5.58599C22.2267 7.41542 22.9091 9.59076 22.9091 11.8195C22.9091 14.0482 22.2267 16.2235 20.9535 18.0529C20.8707 18.1716 20.8384 18.3183 20.8638 18.4607C20.8892 18.6031 20.9701 18.7297 21.0887 18.8125C21.2075 18.8953 21.3542 18.9276 21.4966 18.9022C21.639 18.8768 21.7655 18.7958 21.8483 18.6772C23.2491 16.6646 24 14.2714 24 11.8192C24 9.36699 23.2491 6.97393 21.8483 4.96124V4.96172Z"
              fill="currentColor"
            />{' '}
            <path
              d="M17.6055 7.63213C17.4868 7.7149 17.406 7.84151 17.3807 7.98395C17.3554 8.12638 17.3877 8.27307 17.4705 8.39172C18.1707 9.39763 18.5461 10.5939 18.5461 11.8195C18.5461 13.0451 18.1707 14.2415 17.4705 15.2473C17.3849 15.3658 17.3506 15.5137 17.375 15.6577C17.3994 15.8018 17.4807 15.9301 17.6005 16.0138C17.7203 16.0975 17.8687 16.1296 18.0123 16.1029C18.156 16.0762 18.283 15.9931 18.3648 15.8719C19.193 14.6829 19.637 13.2684 19.637 11.8194C19.637 10.3704 19.1931 8.95602 18.3648 7.76688C18.282 7.64822 18.1555 7.56735 18.0131 7.54206C17.8707 7.51678 17.724 7.54907 17.6055 7.63193V7.63213Z"
              fill="currentColor"
            />{' '}
          </g>{' '}
          <defs>
            {' '}
            <clipPath id="clip0_59_39">
              {' '}
              <rect
                width="24"
                height="24"
              />{' '}
            </clipPath>{' '}
          </defs>
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
